import React from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import { useQuery, gql } from '@apollo/client';
import styled from 'styled-components';
import Feedback from './Feedback';
import ConfirmEmail from './ConfirmEmail';
import ChangeEmail from './ChangeEmail';
import RegistrationForm from './RegistrationForm';
import AuthenticationForm from './AuthenticationForm';
import ResetTokenChecker from './ResetTokenChecker';
import RegisterAtAnother from './RegisterAtAnother';
import Footer from './Footer';
import Header from './Header';
import MandantRegisterHeadline from './MandantRegisterHeadline';
import Box from '../../styledComponents/Box';
import ConfirmInvite from './ConfirmInvite';

const ME_QUERY = gql`
  {
    me {
      _id
      firstName
      lastName
      mobile
      email
    }
  }
`;

const StyledGrid = styled.div`
  height: 100vh;
  display: grid;
  grid-template-columns: auto auto auto;
  margin-left: 10px;
  margin-right: 10px;
  /* margin: 10px; */
`;

const StyledContent = styled(Box)`
  justify-self: center;
  align-self: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-left: 10px;
  margin-right: 10px;
  /* max-width: 310px; */
  padding-bottom: 30px;
  padding-left: 10px;
  padding-top: 30px;
  padding-right: 10px;

  @media (min-width: 600px) {
    padding-left: 40px;
    padding-right: 40px;
    width: 450px;
    max-width: 450px;
  }
`;

function AuthenticationPage() {
  const { loading, data } = useQuery(ME_QUERY, { fetchPolicy: 'network-only' });

  if (loading) {
    return null;
  }

  if (data && data.me) {
    return (
      <StyledGrid>
        <div />
        <StyledContent>
          <Header />

          <Switch>
            <Route
              path='/register/at/:mandantRegisterId'
              render={({ match }) => {
                return (
                  <RegisterAtAnother
                    user={data.me}
                    mandantRegisterId={match.params.mandantRegisterId}
                  />
                );
              }}
            />
            <Route
              path='/authentication/change-email/:changeEmailToken'
              component={ChangeEmail}
            />
            <Route path='/authentication/confirm' component={Feedback} />
            <Route
              path='/authentication/confirm-invite'
              component={ConfirmInvite}
            />

            <Route
              render={props => {
                return <Redirect to='/' />;
              }}
            />
          </Switch>
        </StyledContent>
        <div />
      </StyledGrid>
    );
  } else {
    localStorage.removeItem('auth_token');
  }

  return (
    <StyledGrid>
      <div />
      <StyledContent>
        <Header />
        <Route
          path='/register/at/:mandantRegisterId'
          render={props => <MandantRegisterHeadline />}
        />

        <Switch>
          <Route
            path='/authentication/confirm-email/:activationToken'
            component={ConfirmEmail}
          />
          <Route
            path='/authentication/change-email/:changeEmailToken'
            component={ChangeEmail}
          />
          <Route path='/authentication/confirm' component={Feedback} />
          <Route
            path='/authentication/confirm-invite'
            component={ConfirmInvite}
          />
          <Route
            path='/authentication/initiate-password-reset'
            component={AuthenticationForm}
          />
          <Route
            path='/authentication/reset-password/:resetToken'
            render={props => <ResetTokenChecker {...props} />}
          />
          <Route path='/login' component={AuthenticationForm} />
          <Route path='/register/new' component={AuthenticationForm} />
          <Route
            path='/register/at/:mandantRegisterId'
            component={props => <RegistrationForm {...props} />}
          />
          <Route render={() => <Redirect to='/' />} />
        </Switch>

        <Footer />
      </StyledContent>
      <div />
    </StyledGrid>
  );
}

export default AuthenticationPage;
